import InvoiceActions from "../../actions/InvoiceActions";

var React = require('react');
var Link = require('react-router').Link;
var Table = require('react-bootstrap').Table;

var ButtonLink = require('react-router-bootstrap').ButtonLink;

import InvoiceStore from "../../stores/Invoice/InvoiceStore";
var GroupTable = require('./GroupTable');
var InvoiceTable = require('../Invoice/Table');
import PageHeader from '../Layout/PageHeader';
import ClientStore from "../../stores/ClientStore";
import Currency from "../../util/Currency";

function getState() {
    return {
        credits: InvoiceStore.get().credits
    };
}

var AccountingView = React.createClass({
    componentDidMount: function() {
        InvoiceStore.addChangeListener(this.update);
    },
    componentWillUnmount: function () {
        InvoiceStore.removeChangeListener(this.update);
    },
    getInitialState: function () {
        return getState();
    },
    render: function () {
        return <section id="accounting">
            <PageHeader><h1>Accounting Management</h1></PageHeader>

            <div className="row">
                <div className="col-md-4">
                    <section>
                        <h2>Saved Cards</h2>
                        <ButtonLink bsStyle="primary" to="payment-methods">Manage Saved Cards</ButtonLink>
                    </section>
                </div>
                <div className="col-md-8">
                    {this.state.credits && this.renderCredits()}
                </div>
            </div>

            <h2>Invoices</h2>
            <InvoiceTable>
                <p>
                    PDF copies of invoices may not be immediately available. The process
                    can take up to 60 minutes for them to be created.
                </p>
            </InvoiceTable>
        </section>;
    },
    renderCredits: function () {
        let creditTotal = 0;
        for (let i = 0; i < this.state.credits.length; i++) {
            creditTotal += parseFloat(this.state.credits[i].credits);
        }
        if (!creditTotal) {
            return;
        }

        if (this.state.credits.length === 1) {
            return <div>
                <h2>Credits</h2>
                <div className="alert alert-info">
                    Your account is {Currency.format(this.state.credits[0].credits)} in credit.
                    Your credit will be applied automatically to new invoices.
                </div>
            </div>;
        }

        return <div>
            <h2>Credits</h2>
            <p>Credit will be applied automatically to new invoices in their billing group.</p>
            <Table className="table-striped table-hover">
                <thead><tr>
                    <th>Billing Group</th>
                    <th>Credit</th>
                </tr></thead>
                <tbody>
                    {this.state.credits.map(cred => parseFloat(cred.credits) > 0 && <tr key={cred.billingGroupID}>
                        <td>{cred.billingGroupID} {cred.billingGroupName}</td>
                        <td>{Currency.format(cred.credits)}</td>
                    </tr>)}
                </tbody>
            </Table>
        </div>
    },
    update: function () {
        this.setState(getState());
    }
});
module.exports = AccountingView;



// WEBPACK FOOTER //
// ./app/components/Accounting/View.js